<template>
  <div class="stockup" ref="maChart" id="main">
  </div>
</template>

<script>
// categories :(function () {
//   let now = new Date();
//   let res = [];
//   let len = 10;
//   while (len--) {
//     res.unshift(now.toLocaleTimeString().replace(/^\D*/, ''));
//     now = new Date(+now - 2000);
//   }
//   return res;
// })(),
import elementResizeDetectorMaker from "element-resize-detector";
export default ({
  // //1. 获取到时间
  // props: {
  //   moveTime: null
  // },
  data () {
    return {
      option: {},
      // timer: null
    };
  },
  // beforeDestroy () {
  //   //2.销毁前清除定时器
  //   clearInterval(this.timer);
  // },
  // echartsFun () {
  //   let brokenView = this.echarts.init(this.$refs.broken1);
  //   //3.设置定时器
  //   this.timer = setInterval(() => {
  //     //option....
  //   }, this.moveTime)

  //   //4.清除整个对象
  //   brokenView.clear();
  //   brokenView.setOption(option)
  // },

  methods: {
    // 获取列表
    getData () {


    },

    initOption () {
      var data = [];
      let len = 10;
      while (len--) {
        data.push(Math.round(Math.random() * 1000));
      }


      var data2 = [];
      let i = 0;
      while (i < 10) {
        data2.push(+(Math.random() * 10 + 5).toFixed(1));
        i++;
      }
      let that = this;

      this.option = {
        // 标题的一些配置参数
        title: {
          text: '柱状图'
        },
        //鼠标点击出现的文字
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          }
        },
        legend: {},
        toolbox: {
          show: true,
          iconStyle: {
            borderColor: "#FFF", // 图标默认颜色
          },
          emphasis: {
            iconStyle: {
              borderColor: "#FFF",// 图标hover颜色
            },
          },
          // itemSize: 20, // 设置图标大小
          feature: {
            // restore: {},
            // saveAsImage: {},
            /**自定义的工具栏 */
            myTool1: {
              show: true,
              title: '关闭', // 图标hover 显示文字
              icon: 'path://M256.05 568.47c-6.94 0-13.9-2.57-19.32-7.74-11.19-10.67-11.61-28.4-0.93-39.59l156.22-163.77c5.21-5.46 12.4-8.59 19.94-8.67 7.53-0.12 14.81 2.88 20.14 8.22l114.87 115.1L748.1 265.64c10.79-11.08 28.52-11.3 39.59-0.51 11.08 10.79 11.3 28.52 0.51 39.59L567.25 531.44a28.008 28.008 0 0 1-19.89 8.46h-0.17c-7.43 0-14.56-2.96-19.82-8.22L412.73 416.79 276.31 559.8c-5.5 5.77-12.88 8.67-20.26 8.67z',
              // icon: 'image://关闭_o.png',
              onclick: function () {
                that.$echarts.init(that.$refs['maChart']).dispose();
                let parent = that.$refs['maChart'].parentNode;
                // console.log(parent.id, "parent");
                // console.log(this, "this");
                // console.log(that, "that");
                that.$emit('StateChange', 0, parent.id);
                parent.classList.add('hide');
              }
            }

          }
        },
        dataZoom: {
          show: false,
          start: 0,
          end: 100
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: this.categories()
          },
          {
            type: 'category',
            boundaryGap: true,
            data: this.categories2()
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: 'Price',
            max: 30,
            min: 0,
            boundaryGap: [0.2, 0.2]
          },
          {
            type: 'value',
            scale: true,
            name: 'Order',
            max: 1200,
            min: 0,
            boundaryGap: [0.2, 0.2]
          }
        ],
        //表格数据
        series: [
          {
            name: '柱状值',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data
          },
          {
            name: 'Line值',
            type: 'line',
            data: data2
          }
        ]
      }
    },
    categories () {
      let now = new Date();
      let res = [];
      let len = 10;
      while (len--) {
        res.unshift(now.toLocaleTimeString().replace(/^\D*/, ''));
        now = new Date(+now - 2000);
      }
      return res;
    },
    categories2 () {
      let res = [];
      let len = 10;
      while (len--) {
        res.push(10 - len - 1);
      }
      return res;
    },

    init () {
      this.initOption()
      this.option.width = this.width
      this.option.height = this.height
      let myChart = this.$echarts.init(this.$refs['maChart'])
      myChart.setOption(this.option);

      // 随窗口的大小变化自适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      //  随外层div的大小变化自适应
      const _this = this
      let erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.maChart, (e) => {
        _this.$nextTick(() => {
          myChart.resize();
          // 要x,y轴 width,height
          // console.log(myChart, "myChart")
          // console.log(e.parentNode, "node")
          // console.log(e.parentNode.id, "id");

          var parentNodeId = e.parentNode.id
          var domId = document.getElementById(parentNodeId);
          // console.log(domId, "domId")
          // console.log(domId.clientWidth, "width")
          // console.log(domId.clientHeight, "height")
          // console.log(e.clientX, "clientX")
          // console.log(e.clientY, "clientY")

          // 拿到e对应的index
          // 拿到this.myCharts里面对应的数据，给x、y赋值
          // console.log(_this, "this1");
          _this.$emit('SizeChange', domId.clientWidth, domId.clientHeight, parentNodeId)
        })
      })
    }


  },//自定义指令


  mounted () {
    // this.queryNoCard();
    // this.initOption()
    // let myChart = this.$echarts.init(this.$refs['maChart'])
    // myChart.setOption(this.option);
    //  window.addEventListener("resize",()=> {//监听浏览器窗口大小
    //       myChart.resize();
    //     });

    this.init()

    // var chart = echarts.init(dom, 'dark');
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getData();
  },
})
</script>
<style scoped>
.stockup {
  width: 100%;
  height: 100%;
  /* resize: both;
  overflow:auto; */
  position: absolute;
}
</style>
